import Image from "next/image";
import { useRouter } from "next/navigation";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { BsFillExclamationTriangleFill } from "react-icons/bs";
import { IoRefresh } from "react-icons/io5";

import { coinSymbols } from "services/domain/coinSymbols";
import Images from "styles/image-library";
import { Button } from "tw/components/atoms/Button";
import { Markdown } from "tw/components/atoms/Markdown";
import { format2Dec } from "utils/number-to-short-version";

export interface StSOLDeprecatedBodyProps {
  amount?: number;
  stSOLApy?: number;
  closeSettingsPopup: () => void;
}

export const StSOLDeprecatedBody: FC<StSOLDeprecatedBodyProps> = ({
  amount,
  stSOLApy,
  closeSettingsPopup,
}) => {
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <div
      id="stSOL_deprecated_modal"
      className="w-full flex flex-col items-center md:pb-4 px-2 md:px-0"
    >
      <div className="relative mt-4">
        <Image
          src={Images.icons_lidoSOL}
          height={64}
          width={64}
          alt="Input logo"
          className="rounded-full"
        />
      </div>
      <span className="text-center mt-8 text-2xl font-semibold">
        {t("app.redelegate-stSOL")}
      </span>
      <div className="flex gap-2 items-center text-center pl-2 pr-3 py-0.5 text-error-text bg-error-text/10 rounded-lg mt-2">
        <BsFillExclamationTriangleFill className="text-alert-text h-5 w-5" />
        <Markdown
          className="inline force-text-alert"
          text={t("app.stSOL-sunset-message")}
        />
      </div>
      <div className="relative mt-4">
        <p className="w-full text-center text-6xl">{format2Dec(amount ?? 0)}</p>
        <span className="absolute top-0 right-0 translate-x-full text-tertiary-text text-xl">
          {coinSymbols.SOL}
        </span>
      </div>
      {stSOLApy !== undefined && stSOLApy > 0 && (
        <div className="bg-primary/10 text-primary text-base font-semibold px-2.5 py-0.5 rounded-full mt-1">
          {t("appPage.transaction-modals.apy")} {format2Dec(stSOLApy)}%
        </div>
      )}
      <Button
        variant="primary"
        label={t("app.redelegate")}
        leftIcon={<IoRefresh className="w-6 h-6" />}
        className="w-full mb-2 mt-8"
        onClick={() => {
          router.push("/redelegate/?input=stSOL");
          closeSettingsPopup();
        }}
      />
      <Button
        variant="secondary"
        label={t("appPage.transaction-modals.cancel-button")}
        className="w-full"
        onClick={() => {
          closeSettingsPopup();
        }}
      />
    </div>
  );
};
